
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93217emvOawSlfQIbBZsWf9XGd_2wGzhYZOBWFrhj3bBEMeta } from "/app/pages/file/[id].vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as _91slug_93Ca7NLJbqGOHUNqnKLXkXf2QE028X1k__ZEBA6dPIE_450Meta } from "/app/pages/area/[slug].vue?macro=true";
import { default as indexiURqzwEMLBjcMhjdB_45buej0RjYAdTvfccyarKO8hj2YMeta } from "/app/pages/cerca/index.vue?macro=true";
import { default as index5Lcx7Q_vzd4aL9AFxplhHCW3psMrTVt6Ug2KZWwPoXIMeta } from "/app/pages/cookie/index.vue?macro=true";
import { default as _91id_938rw5yXwPwVlQXj2uLCjDcTFLcviqMm1VMq3Y_1tsVfwMeta } from "/app/pages/quesiti/[id].vue?macro=true";
import { default as indexGn5hilvAiG4MsMa0w6r0_I2Vz2Rc7iYirIbSQUv8yWkMeta } from "/app/pages/clienti/index.vue?macro=true";
import { default as index3QVto7YaRvrcK_45RThDEVqU81KeylBnnPhDLTNw6QcasMeta } from "/app/pages/memoweb/index.vue?macro=true";
import { default as indexnKMlM3fmBazf_lvKLDDvp8Xc_45NwGf56sXRycNgaRJpIMeta } from "/app/pages/myomnia/index.vue?macro=true";
import { default as indexKsE_tefodv68TAoLlXbtIN6Ad0oUw42miDP7YfmS42YMeta } from "/app/pages/notizie/index.vue?macro=true";
import { default as index5t_4515327WHlreIdVbmH6bKIHubwoazT9y1jlNOUAVesMeta } from "/app/pages/privacy/index.vue?macro=true";
import { default as index_dDCuHuvqJOeFoDOgLHgB8JzFFivIqGUvcMQ9kYpPGEMeta } from "/app/pages/quesiti/index.vue?macro=true";
import { default as indexNIFvOO49Oe_xMEuMPT0s2NMCg3C6plPinUQPs7JkGxQMeta } from "/app/pages/riviste/index.vue?macro=true";
import { default as indexKJsFaQDYTs5DoVAiS2HcdoYWgKhFXh2ThN8PkAkQc4kMeta } from "/app/pages/servizi/index.vue?macro=true";
import { default as _91id_93Ui1pUFY3Q4e3WSU4Mhb4FYpdl5hyEPusxXcXa_45oaF6cMeta } from "/app/pages/admin/hub/[id].vue?macro=true";
import { default as index5OjT6BEjYakpplRQckcpk6nrWKoRlp0Pa9hWQIVTb9YMeta } from "/app/pages/tutorial/index.vue?macro=true";
import { default as _91id_93vRIcZiqyb3vUNPoADK9dIib6U3MVcCyKP0E3vfoB6iAMeta } from "/app/pages/admin/aree/[id].vue?macro=true";
import { default as _91id_93xCTlyvTOLSLNXUFkhSOaMgcn_MMkJBCy7f5kDiOKIqIMeta } from "/app/pages/admin/menu/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93nPoXnGgPuBPT0JtOvbaHpnMtZW3KTVuPVxyY9NEGkLkMeta } from "/app/pages/hub/[id]-[slug].vue?macro=true";
import { default as indexY_45AGQXqMZia0ZuqM0azwYpxVm9dTvYwapG4yACdNSqQMeta } from "/app/pages/admin/aree/index.vue?macro=true";
import { default as indexUMWUK_Mie1gK4hdGPr7CAvV3J237GuTucjFKba5lwLcMeta } from "/app/pages/admin/menu/index.vue?macro=true";
import { default as indexA1RrvRuPF6YLaXVbDeLKV6YTHMymf_452Ywir6NyYNAYwMeta } from "/app/pages/admin/drive/index.vue?macro=true";
import { default as _91id_93UrC1GM_45EQOvoYcCA8IGXHhpT_ljnJoJ15oqmTM27adkMeta } from "/app/pages/admin/utenti/[id].vue?macro=true";
import { default as indexPy8q8UncGgTh_45g6Ce4ZNPnhjjs0hH_450Gs_457YnEUzz_AMeta } from "/app/pages/note-legali/index.vue?macro=true";
import { default as indexpXK_45Z2bL9Igz_6Ffg37BFpgsQGPIHNkpUAu4_45bkBDYoMeta } from "/app/pages/scadenzario/index.vue?macro=true";
import { default as _91id_93gwmzxPdmhyeL_459N3Uqzq7MhfSAVTK_zQBkrMbXD_9jMMeta } from "/app/pages/admin/clienti/[id].vue?macro=true";
import { default as _91id_93Xa6__45lsOWYXRZp5fat3rMEbNJ66ZL5BaGGSuk4IynrQMeta } from "/app/pages/admin/memoweb/[id].vue?macro=true";
import { default as indexiCBDXBFpbo7wA4XvzuyQQ4T8lCMrDpwoRcjqyBLgGtEMeta } from "/app/pages/admin/utenti/index.vue?macro=true";
import { default as indexrGPsQ2GE5Ha7XjSkIk8vRU4glAb94Gqg_45vfOSifx5kMMeta } from "/app/pages/admin/clienti/index.vue?macro=true";
import { default as indexEjsqAWj3aNM5UDcfegY7i0tjXaNW4s01ScWhJDvUJvcMeta } from "/app/pages/admin/memoweb/index.vue?macro=true";
import { default as _91id_9337s6O8kcZIzhEtF4Xl1GcQYUNRYRfzbyMj6gbCc_45WZ8Meta } from "/app/pages/admin/prodotti/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93vcVeSv5vcAduc1BI_9Dr_45HJ3KGEy8f6b2g4elyIfOzMMeta } from "/app/pages/memoweb/[id]-[slug].vue?macro=true";
import { default as _91id_93_45_91slug_93_DJn7oYdyDj9susr3uRkR69VxHLLmsTqiJ9rAaGD3Z4Meta } from "/app/pages/riviste/[id]-[slug].vue?macro=true";
import { default as indexOlXux1sS_45Uedvfw2ZIUOYSQVxEBi0dg_45FU0S5MRx_FQMeta } from "/app/pages/admin/prodotti/index.vue?macro=true";
import { default as _91id_93CzC03HIzwd6KMODCfSJSNyIZ7XuAXgTEx_zg2cxtrzoMeta } from "/app/pages/amministrazione/[id].vue?macro=true";
import { default as indexyibUZAgPxk6eIN2qvzBjFJ6cdPWioNigOWyhEz1Z_gAMeta } from "/app/pages/admin/blacklist/index.vue?macro=true";
import { default as _91id_93Gm40FRl4rClUN_455v3pHlSXYz57DqiwHmT9hoJLEm7RAMeta } from "/app/pages/admin/drive/file/[id].vue?macro=true";
import { default as _91id_93rjm0s_45TROPJMudV05X5xV8MowYtdyTKqi_45ZEceDFV4UMeta } from "/app/pages/admin/newsletter/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93FFHK2Eu2yEDO7W5Ht7vw3vl4n0niOCpwagxMYbLpD3cMeta } from "/app/pages/dettaglio/[id]-[slug].vue?macro=true";
import { default as indexhaRdsGTfsPLEUTZZIleAXoUcKfoUBu3Qn_cGlI9HMpEMeta } from "/app/pages/admin/newsletter/index.vue?macro=true";
import { default as _91id_93xveX3jF33MKrq__fa43aIqSav0bE7spM8He04YG40nEMeta } from "/app/pages/admin/drive/folder/[id].vue?macro=true";
import { default as indexcd2lpAN1ffe_poCnNZDxOwFgN7Q81HaWb16YWJX_qwwMeta } from "/app/pages/quesiti/assegnati/index.vue?macro=true";
import { default as notizieNhHc_5aFR3ZSKPl3FrXs24p0oTuDGN5f6HcTDilpGiYMeta } from "/app/pages/area/[area_slug]/notizie.vue?macro=true";
import { default as _91id_93_45i750Ott0DvtdYFBv1Ga6KzHoHQoRqEJeG_lCiXz8_45sMeta } from "/app/pages/admin/contenuti/link/[id].vue?macro=true";
import { default as _91id_93C5i7DMysEvJxwzy1hjmSlpO4Ntf_uYDDgZWOz3F1jXcMeta } from "/app/pages/admin/richieste-demo/[id].vue?macro=true";
import { default as indexDM9bYpf5DfWpmERBnlp3QYIleM_45AoyIw6I3LiOz4IXkMeta } from "/app/pages/admin/utilita/cache/index.vue?macro=true";
import { default as index03zCJFcH8FxkS_pmX6Ut7Nyl9wyh6gqkMUHHkz_RygQMeta } from "/app/pages/admin/contenuti/link/index.vue?macro=true";
import { default as _91id_93CT8prC4wJYWuciyCFSwvDOa4yI_45ddtfNU77ACnqQAmsMeta } from "/app/pages/admin/contenuti/norma/[id].vue?macro=true";
import { default as _91id_933zQCp43C8r2Qz1k86HnezPWBxeGOfTMl7WKKxPCOEFMMeta } from "/app/pages/admin/quesiti-inviati/[id].vue?macro=true";
import { default as index3XLsrsOR8p_45LrHedemAY7CeOdwBRqY9oM6Z4VfBavgoMeta } from "/app/pages/admin/richieste-demo/index.vue?macro=true";
import { default as indexDaDVQAwhsKlV_UWCB3czq_45o75KqD3s3Dc8ijYKlcnLIMeta } from "/app/pages/admin/contenuti/norma/index.vue?macro=true";
import { default as _91id_93hq7DkPU_xaXYJ5i5GSdKsbS_45N7UaK3L12B0LcDYc8HAMeta } from "/app/pages/admin/contenuti/postit/[id].vue?macro=true";
import { default as indexvjThjRw2mpaaYm1xfG2r303xjKAjKAGuwC1eGVrTC2sMeta } from "/app/pages/admin/quesiti-inviati/index.vue?macro=true";
import { default as _91id_93Gz49ul743zNhjJK_HSlrxX_45glXUz2ute_0qNqpXwwjoMeta } from "/app/pages/admin/contenuti/modello/[id].vue?macro=true";
import { default as _91id_93GBP34GYoDuuU4ye0XDuu9Jv4tfN74p1aCigHGQjef2oMeta } from "/app/pages/admin/contenuti/notizia/[id].vue?macro=true";
import { default as indexTDeRYjBlr_ySjsUWfY7CfXk_iy1iQuuwOP0x9hGZdAEMeta } from "/app/pages/admin/contenuti/postit/index.vue?macro=true";
import { default as _91id_93I_gVB88I5ydhC_axl3ooC_45KCViZRRRjNUv26FhrZ720Meta } from "/app/pages/admin/contenuti/pratica/[id].vue?macro=true";
import { default as _91id_93T2zaDsjRtaCaG9xkoImZod2rJAxAcVOvppHz7gWK6tUMeta } from "/app/pages/admin/contenuti/quesito/[id].vue?macro=true";
import { default as _91id_931oeQcG9qhh5UzKG21eBnJle9nfOBJoZzgREHXu_45r16MMeta } from "/app/pages/admin/contenuti/rivista/[id].vue?macro=true";
import { default as _91id_93_45_91slug_931m0wPWolwfnsii6_45SA6iDRGR1vapoGm_45pt_45Sq49y28IMeta } from "/app/pages/area/[area_slug]/[id]-[slug].vue?macro=true";
import { default as scadenzarioWsEkP0rB5qlWQdRivvlZ1HEoVvopVaGhOYTFDLV4O48Meta } from "/app/pages/area/[area_slug]/scadenzario.vue?macro=true";
import { default as indexdDGdwH0ZX5jLxjrcKghVOekdq3dwujRGwf6KJdCXqVUMeta } from "/app/pages/admin/contenuti/modello/index.vue?macro=true";
import { default as indexZ92g58zdBIfyhq5ksjnmL64D_sR1SgpAvLq_45NIfsr_45oMeta } from "/app/pages/admin/contenuti/notizia/index.vue?macro=true";
import { default as index4DWMG1_45uJ6tL9daPzStx_SUTf_w_1am639gv4QEMKqcMeta } from "/app/pages/admin/contenuti/pratica/index.vue?macro=true";
import { default as index2nTYjJcuhbSU33QR6djsPdaPxCl6gopIg2SVk5PEyyAMeta } from "/app/pages/admin/contenuti/quesito/index.vue?macro=true";
import { default as index_yI_LeAQyJZuIo97c0QPoQaNXt41X2PTNQny7SLcZAcMeta } from "/app/pages/admin/contenuti/rivista/index.vue?macro=true";
import { default as _91id_9319_456Jx_45z6TqCW_45_45ZoMw7KaZpGovTbxMB446vWCmMW3YMeta } from "/app/pages/admin/contenuti/scadenza/[id].vue?macro=true";
import { default as indexkjai8fRDFwGPbwngV_45uCpifZC0KkgM5XK2nRKEDWFDoMeta } from "/app/pages/admin/utilita/contenuti/index.vue?macro=true";
import { default as index6UmHZaq1aSpYCsQgHORuHTcLka9PcKxkqx9QDwvYdzkMeta } from "/app/pages/admin/contenuti/scadenza/index.vue?macro=true";
import { default as _91id_93IXf0lxjySLsSkzhA4X91Ee5Y2hnB2p21KgaEatRo3R0Meta } from "/app/pages/admin/contenuti/adempimento/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93Pd5HEgl6NHkMZlf1fdhYHWOY5MdSrns8Fprz4m8lo4IMeta } from "/app/pages/area/[area_slug]/hub/[id]-[slug].vue?macro=true";
import { default as indexPJ807x6iaA1ky3xwPWqAzHROcjtwQg25hQQhtWBceKIMeta } from "/app/pages/admin/contenuti/adempimento/index.vue?macro=true";
import { default as indexFWlykoyDya7ICvZQiVuFnLzIAIrmcaSP3f_45E3FLuJBsMeta } from "/app/pages/dichiarazione-accessibilita/index.vue?macro=true";
import { default as index3WaWmWuX40XXI3GEnRhMGq1ZoUMbMHUkUUMO1xnUNYgMeta } from "/app/pages/gazzetta-e-portali-pubblici/index.vue?macro=true";
import { default as _91id_93uxq2WOqX6MffFhyicvLFP0SZqSvMSDjiPgtPOqxJdbcMeta } from "/app/pages/admin/contenuti/articolo-norma/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93H_4598geAd8AJmrnMe3yePkeg0SZuzIj_45R2mL_45NoNZJesMeta } from "/app/pages/hub/[hub_id]-[hub_slug]/[id]-[slug].vue?macro=true";
import { default as index_Nebp4ot_ylHYHv9AwlKB3OGy4W2OAEGXbqhPLAf7wUMeta } from "/app/pages/informazioni-per-il-cittadino/index.vue?macro=true";
import { default as _91id_93FGJbqznEVPXg7A0tLLUSO18R3heeJ9Y36sn3tb3dGb8Meta } from "/app/pages/admin/contenuti/articolo-rivista/[id].vue?macro=true";
import { default as indexb56pMUi0pLgr_45Lf_45brE_45ZBKL1sEskYwLMHzuiN5nhC4Meta } from "/app/pages/admin/statistiche/esporta-utenti/index.vue?macro=true";
import { default as _91id_93daKj_2RetWHhdD11GSuBsgfI_45GrJQbJi_45pmcrNyWzLQMeta } from "/app/pages/admin/contenuti/scadenza-elettorale/[id].vue?macro=true";
import { default as _91id_93ZD8s_ieSXGbr9s1eunn4tAgt4A4Bub79Vck3n79wMikMeta } from "/app/pages/admin/contenuti/scadenzario-elettorale/[id].vue?macro=true";
import { default as indexWhPHyh7lBqj4b5_45cz3vA645jVv7_7_454TXP6QgW1iVEUMeta } from "/app/pages/admin/contenuti/scadenzario-elettorale/index.vue?macro=true";
import { default as _91id_93_45_91slug_93wMuLJbczFKDMa0qN6EIDqgqhnJy6ycOa3K6Bx_cDlP0Meta } from "/app/pages/memoweb/[memoweb_id]-[memoweb_slug]/[id]-[slug].vue?macro=true";
import { default as _91id_93_45_91slug_93ssNMdbWbvhg_45TSg_45SzdFDvfdZceS_45ic_yopAOSDoE_45kMeta } from "/app/pages/riviste/[rivista_id]-[rivista_slug]/[id]-[slug].vue?macro=true";
import { default as _91id_93BfZXdl_NSHTk_45ZoItwouCqoFWYkZ2iYCQA_457s_45StqdcMeta } from "/app/pages/admin/contenuti/rivista/[rivista_id]/numero/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93pH3FeFX_45U4yl_eoL2uzSDsi8O5xYiWi6c5pbQJ2ytzQMeta } from "/app/pages/area/[area_slug]/hub/[hub_id]-[hub_slug]/[id]-[slug].vue?macro=true";
import { default as _91id_93LZR4Wx7RBzh7hQfnWxDHeQnAM55Z4CWtch5MRfPl_tcMeta } from "/app/pages/admin/contenuti/rivista/[rivista_id]/numero/[numero_id]/capitolo/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "file-id",
    path: "/file/:id()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/file/[id].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "area-slug",
    path: "/area/:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[slug].vue")
  },
  {
    name: "cerca",
    path: "/cerca",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/cerca/index.vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/cookie/index.vue")
  },
  {
    name: "quesiti-id",
    path: "/quesiti/:id()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/quesiti/[id].vue")
  },
  {
    name: "clienti",
    path: "/clienti",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/clienti/index.vue")
  },
  {
    name: "memoweb",
    path: "/memoweb",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/memoweb/index.vue")
  },
  {
    name: "myomnia",
    path: "/myomnia",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/myomnia/index.vue")
  },
  {
    name: "notizie",
    path: "/notizie",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/notizie/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/privacy/index.vue")
  },
  {
    name: "quesiti",
    path: "/quesiti",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/quesiti/index.vue")
  },
  {
    name: "riviste",
    path: "/riviste",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/riviste/index.vue")
  },
  {
    name: "servizi",
    path: "/servizi",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/servizi/index.vue")
  },
  {
    name: "admin-hub-id",
    path: "/admin/hub/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/hub/[id].vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/tutorial/index.vue")
  },
  {
    name: "admin-aree-id",
    path: "/admin/aree/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/aree/[id].vue")
  },
  {
    name: "admin-menu-id",
    path: "/admin/menu/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/menu/[id].vue")
  },
  {
    name: "hub-id-slug",
    path: "/hub/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/hub/[id]-[slug].vue")
  },
  {
    name: "admin-aree",
    path: "/admin/aree",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/aree/index.vue")
  },
  {
    name: "admin-menu",
    path: "/admin/menu",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/menu/index.vue")
  },
  {
    name: "admin-drive",
    path: "/admin/drive",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/drive/index.vue")
  },
  {
    name: "admin-utenti-id",
    path: "/admin/utenti/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/utenti/[id].vue")
  },
  {
    name: "note-legali",
    path: "/note-legali",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/note-legali/index.vue")
  },
  {
    name: "scadenzario",
    path: "/scadenzario",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/scadenzario/index.vue")
  },
  {
    name: "admin-clienti-id",
    path: "/admin/clienti/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/clienti/[id].vue")
  },
  {
    name: "admin-memoweb-id",
    path: "/admin/memoweb/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/memoweb/[id].vue")
  },
  {
    name: "admin-utenti",
    path: "/admin/utenti",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/utenti/index.vue")
  },
  {
    name: "admin-clienti",
    path: "/admin/clienti",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/clienti/index.vue")
  },
  {
    name: "admin-memoweb",
    path: "/admin/memoweb",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/memoweb/index.vue")
  },
  {
    name: "admin-prodotti-id",
    path: "/admin/prodotti/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/prodotti/[id].vue")
  },
  {
    name: "memoweb-id-slug",
    path: "/memoweb/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/memoweb/[id]-[slug].vue")
  },
  {
    name: "riviste-id-slug",
    path: "/riviste/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/riviste/[id]-[slug].vue")
  },
  {
    name: "admin-prodotti",
    path: "/admin/prodotti",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/prodotti/index.vue")
  },
  {
    name: "amministrazione-id",
    path: "/amministrazione/:id()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/amministrazione/[id].vue")
  },
  {
    name: "admin-blacklist",
    path: "/admin/blacklist",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/blacklist/index.vue")
  },
  {
    name: "admin-drive-file-id",
    path: "/admin/drive/file/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/drive/file/[id].vue")
  },
  {
    name: "admin-newsletter-id",
    path: "/admin/newsletter/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/newsletter/[id].vue")
  },
  {
    name: "dettaglio-id-slug",
    path: "/dettaglio/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/dettaglio/[id]-[slug].vue")
  },
  {
    name: "admin-newsletter",
    path: "/admin/newsletter",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/newsletter/index.vue")
  },
  {
    name: "admin-drive-folder-id",
    path: "/admin/drive/folder/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/drive/folder/[id].vue")
  },
  {
    name: "quesiti-assegnati",
    path: "/quesiti/assegnati",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/quesiti/assegnati/index.vue")
  },
  {
    name: "area-area_slug-notizie",
    path: "/area/:area_slug()/notizie",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[area_slug]/notizie.vue")
  },
  {
    name: "admin-contenuti-link-id",
    path: "/admin/contenuti/link/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/link/[id].vue")
  },
  {
    name: "admin-richieste-demo-id",
    path: "/admin/richieste-demo/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/richieste-demo/[id].vue")
  },
  {
    name: "admin-utilita-cache",
    path: "/admin/utilita/cache",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/utilita/cache/index.vue")
  },
  {
    name: "admin-contenuti-link",
    path: "/admin/contenuti/link",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/link/index.vue")
  },
  {
    name: "admin-contenuti-norma-id",
    path: "/admin/contenuti/norma/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/norma/[id].vue")
  },
  {
    name: "admin-quesiti-inviati-id",
    path: "/admin/quesiti-inviati/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/quesiti-inviati/[id].vue")
  },
  {
    name: "admin-richieste-demo",
    path: "/admin/richieste-demo",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/richieste-demo/index.vue")
  },
  {
    name: "admin-contenuti-norma",
    path: "/admin/contenuti/norma",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/norma/index.vue")
  },
  {
    name: "admin-contenuti-postit-id",
    path: "/admin/contenuti/postit/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/postit/[id].vue")
  },
  {
    name: "admin-quesiti-inviati",
    path: "/admin/quesiti-inviati",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/quesiti-inviati/index.vue")
  },
  {
    name: "admin-contenuti-modello-id",
    path: "/admin/contenuti/modello/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/modello/[id].vue")
  },
  {
    name: "admin-contenuti-notizia-id",
    path: "/admin/contenuti/notizia/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/notizia/[id].vue")
  },
  {
    name: "admin-contenuti-postit",
    path: "/admin/contenuti/postit",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/postit/index.vue")
  },
  {
    name: "admin-contenuti-pratica-id",
    path: "/admin/contenuti/pratica/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/pratica/[id].vue")
  },
  {
    name: "admin-contenuti-quesito-id",
    path: "/admin/contenuti/quesito/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/quesito/[id].vue")
  },
  {
    name: "admin-contenuti-rivista-id",
    path: "/admin/contenuti/rivista/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/rivista/[id].vue")
  },
  {
    name: "area-area_slug-id-slug",
    path: "/area/:area_slug()/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[area_slug]/[id]-[slug].vue")
  },
  {
    name: "area-area_slug-scadenzario",
    path: "/area/:area_slug()/scadenzario",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[area_slug]/scadenzario.vue")
  },
  {
    name: "admin-contenuti-modello",
    path: "/admin/contenuti/modello",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/modello/index.vue")
  },
  {
    name: "admin-contenuti-notizia",
    path: "/admin/contenuti/notizia",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/notizia/index.vue")
  },
  {
    name: "admin-contenuti-pratica",
    path: "/admin/contenuti/pratica",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/pratica/index.vue")
  },
  {
    name: "admin-contenuti-quesito",
    path: "/admin/contenuti/quesito",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/quesito/index.vue")
  },
  {
    name: "admin-contenuti-rivista",
    path: "/admin/contenuti/rivista",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/rivista/index.vue")
  },
  {
    name: "admin-contenuti-scadenza-id",
    path: "/admin/contenuti/scadenza/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/scadenza/[id].vue")
  },
  {
    name: "admin-utilita-contenuti",
    path: "/admin/utilita/contenuti",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/utilita/contenuti/index.vue")
  },
  {
    name: "admin-contenuti-scadenza",
    path: "/admin/contenuti/scadenza",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/scadenza/index.vue")
  },
  {
    name: "admin-contenuti-adempimento-id",
    path: "/admin/contenuti/adempimento/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/adempimento/[id].vue")
  },
  {
    name: "area-area_slug-hub-id-slug",
    path: "/area/:area_slug()/hub/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[area_slug]/hub/[id]-[slug].vue")
  },
  {
    name: "admin-contenuti-adempimento",
    path: "/admin/contenuti/adempimento",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/adempimento/index.vue")
  },
  {
    name: "dichiarazione-accessibilita",
    path: "/dichiarazione-accessibilita",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/dichiarazione-accessibilita/index.vue")
  },
  {
    name: "gazzetta-e-portali-pubblici",
    path: "/gazzetta-e-portali-pubblici",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/gazzetta-e-portali-pubblici/index.vue")
  },
  {
    name: "admin-contenuti-articolo-norma-id",
    path: "/admin/contenuti/articolo-norma/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/articolo-norma/[id].vue")
  },
  {
    name: "hub-hub_id-hub_slug-id-slug",
    path: "/hub/:hub_id()-:hub_slug()/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/hub/[hub_id]-[hub_slug]/[id]-[slug].vue")
  },
  {
    name: "informazioni-per-il-cittadino",
    path: "/informazioni-per-il-cittadino",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/informazioni-per-il-cittadino/index.vue")
  },
  {
    name: "admin-contenuti-articolo-rivista-id",
    path: "/admin/contenuti/articolo-rivista/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/articolo-rivista/[id].vue")
  },
  {
    name: "admin-statistiche-esporta-utenti",
    path: "/admin/statistiche/esporta-utenti",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/statistiche/esporta-utenti/index.vue")
  },
  {
    name: "admin-contenuti-scadenza-elettorale-id",
    path: "/admin/contenuti/scadenza-elettorale/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/scadenza-elettorale/[id].vue")
  },
  {
    name: "admin-contenuti-scadenzario-elettorale-id",
    path: "/admin/contenuti/scadenzario-elettorale/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/scadenzario-elettorale/[id].vue")
  },
  {
    name: "admin-contenuti-scadenzario-elettorale",
    path: "/admin/contenuti/scadenzario-elettorale",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/scadenzario-elettorale/index.vue")
  },
  {
    name: "memoweb-memoweb_id-memoweb_slug-id-slug",
    path: "/memoweb/:memoweb_id()-:memoweb_slug()/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/memoweb/[memoweb_id]-[memoweb_slug]/[id]-[slug].vue")
  },
  {
    name: "riviste-rivista_id-rivista_slug-id-slug",
    path: "/riviste/:rivista_id()-:rivista_slug()/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/riviste/[rivista_id]-[rivista_slug]/[id]-[slug].vue")
  },
  {
    name: "admin-contenuti-rivista-rivista_id-numero-id",
    path: "/admin/contenuti/rivista/:rivista_id()/numero/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/rivista/[rivista_id]/numero/[id].vue")
  },
  {
    name: "area-area_slug-hub-hub_id-hub_slug-id-slug",
    path: "/area/:area_slug()/hub/:hub_id()-:hub_slug()/:id()-:slug()",
    meta: {"colorMode":"light"},
    component: () => import("/app/pages/area/[area_slug]/hub/[hub_id]-[hub_slug]/[id]-[slug].vue")
  },
  {
    name: "admin-contenuti-rivista-rivista_id-numero-numero_id-capitolo-id",
    path: "/admin/contenuti/rivista/:rivista_id()/numero/:numero_id()/capitolo/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/pages/admin/contenuti/rivista/[rivista_id]/numero/[numero_id]/capitolo/[id].vue")
  }
]